<template>
    <div>
        <div class="mobile-filter-icon"
             v-if="checkMobileFilterBtn"
             @click="scrollUp">
            <img src="../../../../Assets/Images/filter-icon.svg"
                 alt="filter"
                 @click="checkMobileFilter" />
        </div>
        <aside class="filter" v-if="checkMobileFilterData">
            <section class="gold-link">
                <div @click="checkMobileFilter">{{ BackBtn }} ></div>
            </section>
            <section v-if="surveys" class="surveys">
                <h4 class="title">{{ FilterType }}</h4>
                <div class="checkbox-parent">
                    <label class="custom-checkbox">
                        <input type="checkbox"
                               v-model="assignToMe"
                               @click="assignToMeCheck($event)" />
                        <span class="custom-checkbox__img border-color">
                            <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                        </span>
                        <span>{{ SurveyAssignToMe }}</span>
                    </label>
                </div>
            </section>
            <section class="filter-datepicker" v-if="announcement || rules || surveys">
                <h4>{{ FilterByDate }}</h4>
                <div class="date-wrapper">
                    <div class="date-picker__header">{{ From }}</div>

                    <div class="date-picker">
                        <v-date-picker :locale="{ id: dateLanguage, masks: { L: 'DD MMM YYYY' } }"
                                       v-model="datestart"
                                       :max-date="dateend"
                                       :masks="masks"
                                       :input-props="{ readonly: true }"
                                       :popover="{ placement: 'bottom-end', visibility: 'click' }">
                        </v-date-picker>
                        <img class="datapicker-icon"
                             alt="calendar icon"
                             src="../../../../Assets/Images/Icon-calendar.png" />
                    </div>
                </div>
                <div class="date-wrapper">
                    <div class="date-picker__header date-error">{{ To }}</div>

                    <div class="date-picker">
                        <v-date-picker :locale="{ id: dateLanguage, masks: { L: 'DD MMM YYYY' } }"
                                       v-model.trim="$v.dateend.$model"
                                       :min-date="datestart"
                                       transition="none"
                                       :input-props="{ readonly: true }"
                                       :popover="{ placement: 'bottom-end', visibility: 'click' }">
                        </v-date-picker>
                        <img class="datapicker-icon"
                             alt="calendar icon"
                             src="../../../../Assets/Images/Icon-calendar.png" />
                    </div>
                    <p v-if="$v.dateend.$dirty">
                        <span class="date-error" v-if="!$v.dateend.required">{{ Required }}*</span>
                    </p>
                </div>
                <button class="custom-btn __yellow clear-date" @click="resetDate()">
                    {{ ClearDateFilter }}
                </button>
            </section>

            <section v-if="surveys">
                <h4 class="title">{{ SortByDate }}</h4>
                <div class="custom-radio">
                    <label class="radio-button-container">
                        <span class="radio-text">{{ Ascending }}</span>
                        <input v-model="arrangeByDate"
                               type="radio"
                               name="Yes"
                               value="Asc" />
                        <span class="radio-button-mark"></span>
                    </label>
                </div>
                <div class="custom-radio">
                    <label class="radio-button-container">
                        <span class="radio-text">{{ Descending }}</span>
                        <input v-model="arrangeByDate"
                               type="radio"
                               name="No"
                               value="Desc" />
                        <span class="radio-button-mark"></span>
                    </label>
                </div>
            </section>

            <section>
                <!-- <div class="gold-link" @click="checkMobileFilter">{{ BackBtn }} ></div> -->
                <h4 class="title" v-if="showCategories">{{ categoryLab }}</h4>
                <ul class="main-menu" v-if="showCategories">
                    <li v-for="(item, index) in apiResponse.Categories" :key="index">
                        <div class="checkbox-parent">
                            <label class="custom-checkbox">
                                <input type="checkbox"
                                       @click="selectAll('categories', $event, index)"
                                       v-model="item.checked" />
                                <span class="custom-checkbox__img border-color">
                                    <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                </span>
                            </label>
                            <span class="toggle-second-menu">
                                {{ item.CategoryName }}
                                <a data-toggle="collapse"
                                   :href="'#' + index"
                                   role="button"
                                   aria-expanded="false"
                                   :aria-controls="index"
                                   class="collapsed">
                                    <i v-if="item.SubCategories.length != 0"
                                       class="clickable-btn icon-arrow-down">
                                    </i>
                                </a>
                            </span>
                        </div>
                        <ul class="second-level multi-collapse collapse"
                            :id="index"
                            v-if="item.SubCategories.length != 0">
                            <li v-for="(subItem, indexs) in item.SubCategories" :key="indexs">
                                <label class="custom-checkbox">
                                    <input type="checkbox"
                                           v-model="subItem.checked"
                                           @click="select('categories', index, $event, indexs)" />
                                    <span class="custom-checkbox__img">
                                        <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                    </span>
                                    <span> {{ subItem.value }}</span>
                                </label>
                            </li>
                        </ul>
                    </li>
                </ul>

                <h4 class="title more-filter" v-if="surveys">{{ SurveyMoreFilter }}</h4>
                <!-- Categ Regulations -->
                <h4 class="title" v-if="showCategoriesForRules || showCategoriesForAnnounce">
                    {{ CategoriesOfRules }}
                </h4>
                <ul class="main-menu" v-if="showCategoriesForRules">
                    <li v-for="(item, index) in apiResponse.CategoriesForRules"
                        :key="index">
                        <div class="checkbox-parent">
                            <label class="custom-checkbox">
                                <input type="checkbox"
                                       v-model="item.checked"
                                       @click="selectAll('ruleCategories', $event, index)" />
                                <span class="custom-checkbox__img border-color">
                                    <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                </span>
                            </label>
                            <span class="toggle-second-menu">{{ item.CategoryName }} </span>
                        </div>
                    </li>
                </ul>
                <ul class="main-menu" v-if="showCategoriesForAnnounce">
                    <li v-for="(item, index) in apiResponse.CategoriesForAnnouncements"
                        :key="index">
                        <div class="checkbox-parent">
                            <label class="custom-checkbox">
                                <input type="checkbox"
                                       v-model="item.checked"
                                       @click="selectAll('announceCategories', $event, index)" />
                                <span class="custom-checkbox__img border-color">
                                    <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                </span>
                            </label>
                            <span class="toggle-second-menu">{{ item.CategoryName }} </span>
                        </div>
                    </li>
                </ul>

                <!-- second section -->
                <h4 class="title" v-if="showSectors">{{ sectorLab }}</h4>
                <ul class="main-menu" v-if="showSectors">
                    <li v-for="(item, index) in apiResponse.Sectors" :key="index">
                        <div class="checkbox-parent">
                            <label class="custom-checkbox">
                                <input type="checkbox"
                                       @click="selectAll('sectors', $event, index)"
                                       v-model="item.checked" />
                                <span class="custom-checkbox__img border-color">
                                    <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                </span>
                            </label>
                            <span class="toggle-second-menu">
                                {{ item.Name }}
                                <a data-toggle="collapse"
                                   :href="'#a' + index"
                                   role="button"
                                   aria-expanded="false"
                                   :aria-controls="'a' + index"
                                   class="collapsed">
                                    <i class="clickable-btn icon-arrow-down"
                                       v-if="item.Department.length != 0">
                                    </i>
                                </a>
                            </span>
                        </div>
                        <ul class="second-level multi-collapse collapse"
                            :id="'a' + index"
                            v-if="item.Department.length != 0">
                            <li v-for="(subItem, indexs) in item.Department" :key="indexs">
                                <label class="custom-checkbox">
                                    <input type="checkbox"
                                           v-model="subItem.checked"
                                           @click="select('sectors', index, $event, indexs)" />
                                    <span class="custom-checkbox__img">
                                        <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                    </span>
                                    <span> {{ subItem.value }}</span>
                                </label>
                            </li>
                        </ul>
                    </li>
                </ul>

                <!-- third section -->
                <h4 class="title" v-if="showHealthProducts">
                    {{ productLab }}
                </h4>
                <ul class="main-menu" v-if="showHealthProducts">
                    <li v-for="(item, index) in apiResponse.HealthProducts" :key="index">
                        <div class="checkbox-parent">
                            <label class="custom-checkbox">
                                <input type="checkbox"
                                       @click="selectAll('health', $event, index)"
                                       v-model="item.checked" />
                                <span class="custom-checkbox__img border-color">
                                    <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                </span>
                            </label>
                            <span class="toggle-second-menu">{{ item.Name }} </span>
                        </div>
                    </li>
                </ul>

                <!-- fourth section -->

                <h4 class="title" v-if="showFunctions">{{ functionsLab }}</h4>
                <ul class="main-menu" v-if="showFunctions">
                    <li v-for="(item, index) in apiResponse.Functions" :key="index">
                        <div class="checkbox-parent">
                            <label class="custom-checkbox">
                                <input type="checkbox"
                                       @click="selectAll('func', $event, index)"
                                       v-model="item.checked" />
                                <span class="custom-checkbox__img border-color">
                                    <img src="../../../../Assets/Images/checked-icon.png" alt="icon" />
                                </span>
                            </label>
                            <span class="toggle-second-menu">{{ item.Name }} </span>
                        </div>
                    </li>
                </ul>

                <div class="btns-wrapper-filter">
                    <button class="custom-btn __yellow"
                            :class="filterClicked ? 'dimmet' : ''"
                            @click.prevent="sendData(), filter()">
                        {{ Apply }}
                    </button>
                    <button class="custom-btn __yellow" @click.prevent="reset()">
                        {{ Reset }}
                    </button>
                </div>
            </section>
        </aside>
    </div>
</template>
<script>
    import Vue from "vue";
    import DatePicker from "v-calendar/lib/components/date-picker.umd";
    import Vuelidate from "vuelidate";
    import { requiredIf } from "vuelidate/lib/validators";

    Vue.component("v-date-picker", DatePicker);
    Vue.use(Vuelidate);

    //let mediaQuerySize = window.matchMedia('(max-width: 1025px)');

    export default {
        name: "filterservice",
        validations: {
            dateend: {
                required: requiredIf(function () {
                    return this.datestart;
                }),
            },
        },
        data() {
            return {
                assignToMe: false,
                datePickerObjLang: {
                    ar: "ar",
                    en: "en",
                },
                dateLanguage: "ar",
                datestart: "",
                dateend: null,
                selected: [],
                allSelectedCate: false,
                cateArr: [],
                sectorArr: [],
                subArr: [],
                healthArr: [],
                funcArr: [],
                depArr: [],
                userIds: [],
                arrangeByDate: "Desc",
                tarckApplyFilter: false,
                checkMobileFilterBtn: false,
                checkMobileFilterData: true,
                checkedUsers: [],
                info: null,
                showCategories: false,
                showCategoriesForRules: false,
                showCategoriesForAnnounce: false,
                showHealthProducts: false,
                showFunctions: false,
                showSectors: false,
                showDepartments: false,
                ruleArr: [],
                masks: {
                    input: "YYYY-MM-DD",
                },
            };
        },
        props: [
            "Apply",
            "Reset",
            "apiResponse",
            "filter",
            "categoryLab",
            "sectorLab",
            "productLab",
            "functionsLab",
            "checkCat",
            "categRegulation",
            "CategoriesOfRules",
            "FilterByDate",
            "ClearDateFilter",
            "filterClicked",
            "From",
            "To",
            "PageType",
            "Required",
            "announcement",
            "rules",
            "services",
            "surveys",
            "BackBtn",
            "SortByDate",
            "FilterType",
            "Ascending",
            "Descending",
            "SortType",
            "assignToMeAction",
            "SurveyAssignToMe",
            "SurveyMoreFilter"
        ],
        methods: {
            ShowHideFilters() {
                if (this.rules) {
                    this.getRulesTabShowingFilters();
                } else if (this.announcement) {
                    this.getAnnouncementsTabShowingFilters();
                } else if (this.services) {
                    this.getServicesTabShowingFilters();
                    this.showDepartments = true;
                } else if (this.surveys) {
                    this.getSurveysFilter();
                }
                //-------------------
                if (this.PageType == "rulesAndRegulationsList") {
                    this.getRulesTabShowingFilters();
                } else if (this.PageType == "announce") {
                    this.getAnnouncementsTabShowingFilters();
                } else if (this.PageType == "healthProducts") {
                    this.showHealthProducts = false;
                } else if (this.PageType == "functions") {
                    this.showFunctions = false;
                } else if (this.PageType == "sectorDetails") {
                    this.showSectors = false;
                } else if (this.PageType == "departmentDetails") {
                    this.showSectors = false;
                }
            },
            getRulesTabShowingFilters() {
                this.showCategories = false;
                this.showCategoriesForRules = true;
                this.showHealthProducts = true;
                this.showFunctions = true;
                this.showSectors = true;
                this.showDepartments = false;
            },
            getAnnouncementsTabShowingFilters() {
                this.showCategories = false;
                this.showCategoriesForRules = false;
                this.showCategoriesForAnnounce = true;
                this.showHealthProducts = true;
                this.showFunctions = true;
                this.showSectors = true;
                this.showDepartments = false;
            },
            getServicesTabShowingFilters() {
                this.showCategories = true;
                this.showCategoriesForRules = false;
                this.showHealthProducts = true;
                this.showFunctions = true;
                this.showSectors = true;
                this.showDepartments = true;
            },
            getSurveysFilter() {
                this.showHealthProducts = true;
                this.showFunctions = true;
                this.showSectors = true;
            },
            selectAll(type, e, index) {
                this.apiResponse.Categories[0].checked = false;
                if (type == "categories") {
                    let category = this.apiResponse.Categories[index];
                    if (!this.cateArr.includes(category.CategoryName)) {
                        this.cateArr.push(category.CategoryName);
                    } else {
                        let filtered = this.cateArr.filter(function (value) {
                            return value != category.CategoryName;
                        });
                        this.cateArr = filtered;
                    }
                    
                        for (let categ of category.SubCategories) {
                            if (e.target.checked) {
                                categ.checked = true;
                                if (!this.subArr.includes(categ.value)) {
                                    this.subArr.push(categ.value);
                                }
                            } else {
                                categ.checked = false;
                                let filtered = this.subArr.filter(function (value) {
                                    return value != categ.value;
                                });
                                this.subArr = filtered;
                            }
                        }
                    if (index == 0) {
                        this.handleSelectAll(e, index)
                    }
                } else if (type == "sectors") {
                    let sector = this.apiResponse.Sectors[index];

                    if (!this.sectorArr.includes(sector.Name)) {
                        this.sectorArr.push(sector.Name);
                    } else {
                        let filtered = this.sectorArr.filter(function (value) {
                            return value != sector.Name;
                        });
                        this.sectorArr = filtered;
                    }
                            for (let sec of sector.Department) {
                                if (e.target.checked) {
                                    sec.checked = true;
                                    if (!this.depArr.includes(sec.value)) {
                                        this.depArr.push(sec.value);
                                    }
                                } else {
                                    sec.checked = false;
                                    let filtered = this.depArr.filter(function (value) {
                                        return value != sec.value;
                                    });
                                    this.depArr = filtered;
                                }
                            }

                } else if (type == "health") {
                    let health = this.apiResponse.HealthProducts[index];
                    if (!this.healthArr.includes(health.Name)) {
                        this.healthArr.push(health.Name);
                    } else {
                        let deletedItem = this.healthArr.indexOf(health.Name);
                        this.healthArr.splice(deletedItem, 1);
                    }
                } else if (type == "func") {
                    let func = this.apiResponse.Functions[index];
                    if (!this.funcArr.includes(func.Name)) {
                        this.funcArr.push(func.Name);
                    } else {
                        let deletedItem = this.funcArr.indexOf(func.Name);
                        this.funcArr.splice(deletedItem, 1);
                    }
                } else if (type == "ruleCategories") {
                    let rule = this.apiResponse.CategoriesForRules[index];
                    if (!this.ruleArr.includes(rule.CategoryName.trim())) {
                        this.ruleArr.push(rule.CategoryName.trim());
                    } else {
                        let deletedItem = this.ruleArr.indexOf(rule.CategoryName.trim());
                        this.ruleArr.splice(deletedItem, 1);
                    }
                }
                else if (type == "announceCategories") {
                    let rule = this.apiResponse.CategoriesForAnnouncements[index];
                    if (!this.ruleArr.includes(rule.CategoryName.trim())) {
                        this.ruleArr.push(rule.CategoryName.trim());
                    } else {
                        let deletedItem = this.ruleArr.indexOf(rule.CategoryName.trim());
                        this.ruleArr.splice(deletedItem, 1);
                    }
                }
            },
            select(type, index, e, indexs) {
                if (type == "categories") {
                    let category = this.apiResponse.Categories[index];
                    let subcategory = this.apiResponse.Categories[index].SubCategories[
                        indexs
                    ];
                    let selectAll = true;
                    if (e.target.checked) {
                        subcategory.checked = true;
                        this.subArr.push(subcategory.value);
                    } else {
                        subcategory.checked = false;
                        let filteredcateArr = this.cateArr.filter(function (value) {
                            return value != category.CategoryName;
                        });
                        this.cateArr = filteredcateArr;
                        let filteredsubArr = this.subArr.filter(function (value) {
                            return value != subcategory.value;
                        });
                        this.subArr = filteredsubArr;
                    }

                    for (let categ of category.SubCategories) {
                        if (categ.checked == false) {
                            selectAll = false;
                            break;
                        }
                    }

                    if (selectAll == true) {
                        this.apiResponse.Categories[index].checked = true;
                        this.cateArr.push(category.CategoryName);
                    } else {
                        this.apiResponse.Categories[index].checked = false;
                    }
                } else if (type == "sectors") {
                    let sector = this.apiResponse.Sectors[index];
                    let subSector = this.apiResponse.Sectors[index].Department[indexs];

                    let selectAll = true;
                    if (e.target.checked) {
                        subSector.checked = true;
                        this.depArr.push(subSector.value);
                        if (
                            this.apiResponse.Sectors[index].Department.length ==
                            this.depArr.length
                        ) {
                            this.sectorArr.push(sector.Name);
                        }
                    } else {
                        subSector.checked = false;
                        let filteredcateArr = this.sectorArr.filter(function (value) {
                            return value != sector.Name;
                        });
                        this.sectorArr = filteredcateArr;
                        let filteredsubArr = this.depArr.filter(function (value) {
                            return value != subSector.value;
                        });
                        this.depArr = filteredsubArr;
                    }

                    for (let sec of sector.Department) {
                        if (sec.checked == false) {
                            selectAll = false;
                            break;
                        }
                    }

                    if (selectAll == true) {
                        this.apiResponse.Sectors[index].checked = true;
                    } else {
                        this.apiResponse.Sectors[index].checked = false;
                    }
                }
            },
            sendData() {
                this.$v.dateend.$touch();
                if (!this.$v.dateend.$anyError) {
                    if (this.surveys) {
                        this.$emit("SortType", this.arrangeByDate);
                        this.$emit("assignToMeAction", this.assignToMe);
                    }
                    this.$emit("filterClicked", true);
                    this.$emit("categoryArr", this.cateArr);
                    this.$emit("sectorArr", this.sectorArr);
                    this.$emit("subArr", this.subArr);
                    this.$emit("healthArr", this.healthArr);
                    this.$emit("funcArr", this.funcArr);
                    this.$emit("depArr", this.depArr);
                    this.$emit("tarckApplyFilter", (this.tarckApplyFilter = true));
                    this.$emit("ruleArr", this.ruleArr);
                    this.$emit("datestart", this.datestart);
                    this.$emit("dateend", this.dateend);
                    this.$emit("resetData", this.resetDate);
                    if (window.innerWidth <= 1025) {
                        this.checkMobileFilter();
                    }
                    setTimeout(function () {
                        document.querySelector(".accordion-wrapper").scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                            inline: "start",
                        });
                    }, 500);
                } else if (this.$v.dateend.$anyError) {
                    setTimeout(function () {
                        document.querySelector(".date-error").scrollIntoView({
                            behavior: "smooth",
                            block: "start",
                            inline: "center",
                        });
                    }, 500);
                }
            },
            checkMobileFilter() {
                this.checkMobileFilterBtn = !this.checkMobileFilterBtn;
                this.checkMobileFilterData = !this.checkMobileFilterData;
            },
            reset() {
                if (!this.surveys) {
                    for (let c of this.apiResponse.Categories) {
                        c.checked = false;
                        if (this.services) {
                            for (let sub of c.SubCategories) {
                                sub.checked = false;
                            }
                        }
                    }

                    for (let item of this.apiResponse.CategoriesForRules) {
                        item.checked = false;
                    }
                }

                for (let sec of this.apiResponse.Sectors) {
                    sec.checked = false;
                    if (this.services) {
                        for (let dep of sec.Department) {
                            dep.checked = false;
                        }
                    }
                }

                for (let item of this.apiResponse.HealthProducts) {
                    item.checked = false;
                }
                for (let item of this.apiResponse.Functions) {
                    item.checked = false;
                }


                if (this.surveys) {
                    this.assignToMe = false;
                    this.arrangeByDate = "Desc";
                    this.$emit("SortType", this.arrangeByDate);
                    this.$emit("assignToMeAction", this.assignToMe);
                }
                this.cateArr = [];
                this.sectorArr = [];
                this.subArr = [];
                this.depArr = [];
                this.funcArr = [];
                this.healthArr = [];
                this.ruleArr = [];
                this.datestart = "";
                this.dateend = null;
                this.$emit("categoryArr", this.cateArr);
                this.$emit("sectorArr", this.sectorArr);
                this.$emit("subArr", this.subArr);
                this.$emit("healthArr", this.healthArr);
                this.$emit("funcArr", this.funcArr);
                this.$emit("depArr", this.depArr);
                this.$emit("tarckApplyFilter", (this.tarckApplyFilter = true));
                this.$emit("ruleArr", this.ruleArr);
                this.$emit("datestart", this.datestart);
                this.$emit("dateend", this.dateend);
                this.$emit("resetData", this.resetDate);
                this.filter();
                setTimeout(function () {
                    document.querySelector(".accordion-wrapper").scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "start",
                    });
                }, 500);
                if (window.innerWidth <= 1025) {
                    this.checkMobileFilter();
                }
            },
            resetDate() {
                this.datestart = "";
                this.dateend = null;
            },
            filterReszie() {
                if (window.innerWidth <= 1025) {
                    this.checkMobileFilterBtn = true;
                    this.checkMobileFilterData = false;
                } else {
                    this.checkMobileFilterBtn = false;
                    this.checkMobileFilterData = true;
                }
            },
            scrollUp() {
                document.querySelector(".filter-component").scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start",
                });
            },
            assignToMeCheck(e) {
                if (e.target.checked) {
                    this.assignToMe = true;
                } else {
                    this.assignToMe = false;
                }
            },
            //screenTest(e) {
            //    debugger
            //    if (e.matches) {
            //        this.checkMobileFilterBtn = true;
            //        this.checkMobileFilterData = false;
            //    } else {
            //        this.checkMobileFilterBtn = false;
            //        this.checkMobileFilterData = true;
            //    }
            //}
        },
        //created() {
        //  mediaQuerySize.addEventListener('change', this.screenTest(mediaQuerySize));
        //},
        //destroyed() {
        //  mediaQuerySize.addEventListener('change', this.screenTest(mediaQuerySize));
        //},
        mounted() {
            this.ShowHideFilters();

            this.filterReszie();

            if (
                document.getElementsByTagName("body")[0].getAttribute("dir") === "rtl"
            ) {
                this.dateLanguage = this.datePickerObjLang.ar;
            } else {
                this.dateLanguage = this.datePickerObjLang.en;
            }



            //mediaQuerySize.addEventListener('change', this.screenTest(mediaQuerySize));
        },
    };
</script>
